import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackDepletedActionBlocked.meta';

export type UseTrackDepletedActionBlockedParams = CreditAnalyticsParams & {
  action: 'upload' | 'import' | 'canvas_edit' | 'asset_edit' | 'workspace_agent';
};

export const useTrackDepletedActionBlocked = () => {
  const { track } = useAnalyticsUtilities();

  const trackDepletedActionBlocked = useCallback(
    (params: UseTrackDepletedActionBlockedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDepletedActionBlocked };
};
